import { PostTripType } from '@orbit/api-types'
import { getDeviceContext } from '@lib/analytics'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

export const useCreateTrip = () => {
	const queryClient = useQueryClient()

	return useMutation<Trip, Error, PostTripType>({
		mutationFn: async (tripData) => {
			const response = await api.post<Trip>('/trips', { ...tripData, analytics: getDeviceContext() })
			return response.data
		},
		onSuccess: () => {
			// Invalidate and refetch trips list
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
		},
	})
}

